<template>
  <v-card class="overflow-hidden roster-container px-md-16 mx-md-16 mx-4 elevation-0" color="#F9F6F6" min-height="100vh">
    <!-- Header del influencer -->
    <v-card elevation="0" class="mx-md-12 px-3 py-3" style="border-radius:10px;">
      <v-row class="ma-0" align="center">
        <!-- Col 1 -->
        <v-col cols="12" md="3">
          <v-row class="ma-0" no-gutters align="center">
            <v-skeleton-loader v-if="!loaded" type="avatar, text" class="mr-4" />
            <template v-else>
              <v-avatar size="45" color="red" class="mr-4">
                <v-img :src="influencer.profile_photo_path"/>
              </v-avatar>
              <div class="influencer-data">
                <v-card-title class="pa-0 ma-0">
                  {{ influencer.name + (influencer.last ? (' ' + influencer.last) : '') }}
                </v-card-title>
                <v-card-subtitle class="pa-0 ma-0">
                  {{ influencer.social_networks ? influencer.social_networks[social_switch] : '' }}
                  <v-icon x-small color="#0095F6">mdi-check-decagram</v-icon>
                </v-card-subtitle>
              </div>
            </template>
          </v-row>
        </v-col>

        <v-col cols="12" md="1" class="d-none d-md-block"/>
        <!-- Col 2 -->
        <v-col cols="12" md="4">
          <v-row class="ma-0">
            <v-spacer/>
            <v-row class="ma-0 pt-2 influencer-numbers" v-if="influencer.social_networks">
              <div>
                <span class="pa-0 ma-0 title">{{ influencer[ social_switch + '_followers'] }}</span>
                <span style="color:#7B7B7B;" class="pa-0 ma-0 subtitle">Seguidores</span>
              </div>
              <v-spacer/>
              <div>
                <span class="pa-0 ma-0 title">{{ influencer.social_networks.metrics!=undefined?influencer.social_networks.metrics[social_switch].avg_likes : 0 }}</span>
                <span style="color:#7B7B7B;" class="pa-0 ma-0 subtitle">Avg. likes</span>
              </div>
              <v-spacer/>
              <div>
                <span class="pa-0 ma-0 title">{{ influencer.social_networks.metrics!=undefined?influencer.social_networks.metrics[social_switch].avg_comments : 0 }}</span>
                <span style="color:#7B7B7B;" class="pa-0 ma-0 subtitle">Avg. Comments</span>
              </div>
            </v-row>
            <v-spacer/>
          </v-row>
        </v-col>

        <v-col cols="12" md="1" class="d-none d-md-block"/>
        <!-- Col 3 -->
        <v-col cols="12" md="3">
          <v-row class="ma-0" justify="end">
            <div class="social-switch mt-2">
              <div @click="social_switch='instagram'" :class="social_switch === 'instagram' ? 'active-social-switch' : 'inactive-social-switch'">
                <v-icon color="black" x-small>mdi-instagram</v-icon>
                Instagram
              </div>
              <div @click="social_switch='tiktok'" :class="social_switch === 'tiktok' ? 'active-social-switch' : 'inactive-social-switch'">
                <v-icon color="black" x-small>mdi-instagram</v-icon>
                TikTok
              </div>
            </div>
          </v-row>
        </v-col>
      </v-row>

      <!-- Chips categorías -->
      <v-row class="ma-0 mt-2">
        <v-col cols="12" md="3">
          <template v-if="loaded">
            <v-chip
              v-for="(category, index) in (influencer.categories || [])"
              :key="index"
              outlined
              class="cat-chip"
            >
              {{ category.name }}
            </v-chip>
          </template>
          <v-skeleton-loader
            v-else
            type="chip@3"
            class="mt-1"
          />
        </v-col>

        <v-col cols="12" md="1" class="d-none d-md-block"/>
        <v-col cols="12" md="4">
          <!-- Mock de género (dejado igual) -->
          <v-row class="ma-0" v-if="influencer.social_networks">
            <v-col cols="6" class="pr-md-6">
              <v-row class="ma-0">
                <v-spacer class="d-none d-md-flex"/>
                <div>
                  <v-row class="ma-0" style="font-size:16px!important; font-weight:bold;" >
                    <v-icon style="font-size:18px; transform:translateY(-1px);" color="#F178B6">mdi-gender-female</v-icon>
                    {{influencer.social_networks.metrics!=undefined?influencer.social_networks.metrics[social_switch].female_public : 0}}
                  </v-row>
                  <div style="font-size:10px; color:#767676;">Mujeres</div>
                </div>
              </v-row>
            </v-col>
            <v-col cols="6" class="pl-md-6">
              <v-row class="ma-0">
                <div>
                  <v-row class="ma-0" style="font-size:16px!important; font-weight:bold;" >
                    <v-icon style="font-size:16px;" color="#5D5FEF">mdi-gender-male</v-icon>
                    {{influencer.social_networks.metrics!=undefined?influencer.social_networks.metrics[social_switch].male_public : 0}}
                  </v-row>
                  <div style="font-size:10px; color:#767676;">Hombres</div>
                </div>
              </v-row>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" md="1" class="d-none d-md-block"/>
        <v-col cols="12" md="3">
          <v-row class="ma-0" justify="end">
            <div>
              <template v-if="loaded && influencer.social_networks">
                <v-row class="ma-0" v-for="(row, index) in ages" :key="index">
                  <span class="age-label">{{ row.label }}</span>
                  <div class="age-bar-bg">
                    <div class="age-bar" :style="{ width: ((150/100)*(influencer.social_networks.metrics!=undefined?influencer.social_networks.metrics[social_switch].audience_age[index]:0))+'px' }"></div>
                  </div>
                  <span class="age-pct">{{ (influencer.social_networks.metrics!=undefined?influencer.social_networks.metrics[social_switch].audience_age[index]:0) }}%</span>
                </v-row>
              </template>
              <v-skeleton-loader v-else type="image" height="60" class="mt-2"/>
            </div>
          </v-row>
        </v-col>
      </v-row>
    </v-card>

    <!-- Grid + infinito -->
    <grid class="mx-md-12 mx my-4" :posts="posts" :loading="loading" />

    <!-- Sentinel -->
    <div ref="sentinel" style="height: 1px;"></div>

    <!-- Estado de carga -->
    <div class="py-6 text-center" v-if="loading && posts.length > 0">
      <v-progress-circular indeterminate color="primary" size="24" />
    </div>
    <div class="py-6 text-center grey--text" v-else-if="!posts.length && !loading">
      Sin resultados.
    </div>
  </v-card>
</template>

<script>
import Grid from './Grid.vue'
import axios from 'axios'

export default {
  components: { grid: Grid },
  data () {
    return {
      influencer: {},
      social_switch: 'instagram',

      // posts + infinito
      posts: [],
      page: 1,
      itemsPerPage: 12,
      loading: false,
      hasMore: true,
      io: null, // IntersectionObserver

      loaded: false,
      ages: [
        { label:'0-17' },
        { label:'18-20' },
        { label:'21-24' },
        { label:'25-34' },
        { label:'35-54' }
      ]
    }
  },
  computed: {
    apiBase () { return process.env.VUE_APP_BACKEND_ROUTE },
    influencerId () { return this.$route.query.influencer_id }
  },
  async created () {
    try {
      const { data } = await axios.get(this.apiBase + 'api/v1/talents/' + this.influencerId)
      this.influencer = data.data
      this.loaded = true
    } catch (_) {
      this.loaded = true
    }
  },
  mounted () {
    this.resetAndLoad()
    this.mountObserver()
  },
  beforeDestroy () {
    if (this.io) { this.io.disconnect(); this.io = null }
  },
  watch: {
    influencerId () { this.resetAndLoad() }
  },
  methods: {
    mountObserver () {
      const target = this.$refs.sentinel
      if (!target) return

      const handler = (entries) => {
        const entry = entries && entries[0]
        if (entry && entry.isIntersecting) this.loadMore()
      }

      this.io = new IntersectionObserver(handler, {
        root: null,
        rootMargin: '600px 0px 0px 0px',
        threshold: 0
      })

      this.io.observe(target)
    },

    resetAndLoad () {
      this.page = 1
      this.posts = []
      this.hasMore = true
      this.fetchPosts()
    },

    loadMore () {
      if (this.loading || !this.hasMore) return
      this.page += 1
      this.fetchPosts(true)
    },

    async fetchPosts (append = false) {
      if (this.loading) return
      this.loading = true

      try {
        const params = new URLSearchParams()
        params.set('page', String(this.page))
        params.set('itemsPerPage', String(this.itemsPerPage))
        params.set('sort', '-id')
        params.set('filter[influencer_id]', String(this.influencerId || ''))

        const url = this.apiBase + 'api/v1/roster?' + params.toString()
        const { data } = await axios.get(url)
        const rows = (data && Array.isArray(data.data)) ? data.data : []

        if (!append) this.posts = rows
        else this.posts = this.posts.concat(rows)

        this.hasMore = rows.length === this.itemsPerPage
      } catch (e) {
        this.hasMore = false
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style>
.influencer-data .v-card__title{
  font-size:15px!important;
  font-weight: 400!important;
  line-height: 20px;
  color:black!important;
}
.influencer-data .v-card__subtitle{
  font-size:14px!important;
  color:black!important;
  font-weight: 700!important;
}
.influencer-numbers .title{
  font-size:15px!important;
  line-height: 15px;
}
.influencer-numbers .subtitle{
  font-size:12px!important;
  font-weight: 400!important;
}
.influencer-numbers div{
  text-align: center!important;
  display: grid;
}
.social-switch{
  font-size: 11px!important;
  color:black!important;
  border-radius: 20px;
  padding: 3px;
  background: #F2F1F1;
  display: inline-flex;
  cursor: pointer;
  line-height: 11px;
  gap: 6px;
}
.active-social-switch{
  border-radius: 20px;
  padding: 5px 10px;
  background: white;
  height: 20px;
}
.inactive-social-switch{
  border-radius: 20px;
  padding: 5px 10px;
  height: 20px;
}

/* Chips */
.cat-chip{
  font-size:12px;
  height:24px;
  border-radius:20px;
  margin:5px;
  text-transform:none;
  color:#585858;
}

/* Ages */
.age-label{ font-size:11px; width:36px; }
.age-bar-bg{
  margin:3px 10px;
  width:150px; height:8px;
  background:#F0F0F0; border-radius:5px;
}
.age-bar{
  height:8px; background:#FA9365; border-radius:5px;
}
.age-pct{ font-size:11px; }

/* Mobile paddings */
@media (max-width: 600px){
  .mx-12{ margin-left:12px!important; margin-right:12px!important; }
}
</style>
